import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import competitorChannelsReducer from './slices/competitorChannelsSlice';
import researchReportReducer from './slices/researchReportSlice';
import topicsReducer from './slices/topicsSlice';
import scriptsReducer from './slices/scriptsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    competitorChannels: competitorChannelsReducer,
    researchReport: researchReportReducer,
    topics: topicsReducer,
    scripts: scriptsReducer,
  },
});

